import Box from '@/components/UI/box/Box';
import styles from './NeighbourhoodsEmptyState.module.scss';
import Typography from '@/components/UI/typography/Typography';
import emptyImage from '@/public/images/hostPanel/empty-search-list.svg';
import Image from 'next/image';
const NeighbourhoodsEmptyState = () => {
  return <Box className={styles['empty-state-container']} data-sentry-element="Box" data-sentry-component="NeighbourhoodsEmptyState" data-sentry-source-file="NeighbourhoodsEmptyState.tsx">
      <Image src={emptyImage} alt="empty-state-image" width={142} height={142} data-sentry-element="Image" data-sentry-source-file="NeighbourhoodsEmptyState.tsx" />
      <Typography variant="bodyL_Bold" className={styles['empty-title']} data-sentry-element="Typography" data-sentry-source-file="NeighbourhoodsEmptyState.tsx">
        نتیجه‌ای پیدا نشد!
      </Typography>
      <Typography variant="bodyM" className={styles['empty-description']} data-sentry-element="Typography" data-sentry-source-file="NeighbourhoodsEmptyState.tsx">
        لطفا محله موردنظر خود را از بین گزینه‌ها انتخاب کنید.
      </Typography>
    </Box>;
};
export default NeighbourhoodsEmptyState;